jQuery(document).ready(function ($) {

	$(".js-update-quantity").on("click", function () {
		const $this = $(this),
			row = $this.closest("tr"),
			counter = $this.data("counter"),
			relationId = relation.relationId ? relation.relationId : row.data("relation-id"),
			steelId = relation.steelId ? relation.steelId : row.data("steel-id");

		row.find(".btn-group button").prop("disabled", true);

		$.ajax({
			type: "POST",
			dataType: "json",
			url: relation.url,
			data: {
				action: "assign-stock-to-relation",
				nonce: relation.nonce,
				relationId: relationId,
				representativeId: relation.representativeId,
				steelId: steelId,
				counter: counter,
			},
			beforeSend: function () {

			},
			success: function (response) {

				row.find(".quantity").text(response.data.relationStock);

				if (row.find(".stock").length > 0) {
					row.find(".stock").text(response.data.currentStock);
				}

				if ($(".own-stock span").length > 0) {
					$(".own-stock span").text(response.data.currentStock);

					row.closest(".data_table").find(".btn-group button.plus").prop("disabled", response.data.currentStock === 0);
				}

				row.find(".btn-group button.minus").prop("disabled", response.data.relationStock === 0);
				row.find(".btn-group button.plus").prop("disabled", response.data.currentStock === 0);

				showMessage(response.data.message, "success");
			},
			error: function (jqXHR) {
				if (jqXHR.responseJSON && jqXHR.responseJSON.hasOwnProperty("data")) {
					showMessage(jqXHR.responseJSON.data, "error");

					setTimeout(function () {
						const currentStock = row.find(".stock").length > 0 ? row.find(".stock").text() : $(".own-stock span").text();

						row.find(".btn-group button.minus").prop("disabled", parseInt(row.find(".quantity").text()) === 0);
						row.find(".btn-group button.plus").prop("disabled", parseInt(currentStock) === 0);

					}, 2000);

				}
			},

		});

	});

	function showMessage(message, type) {
		const alertClass = (type === "success") ? "alert-success" : "alert-danger",
			closeButton = "<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>",
			alertHTML = "<div class=\"alert " + alertClass + " alert-dismissible fade show\" role=\"alert\">" + message + closeButton + "</div>";

		$("#message").html(alertHTML);

		setTimeout(function () {
			$("#message .alert").fadeOut("slow", "swing");
		}, 2000);
	}

});